import { useState } from "react"
import { styled } from "@mui/material/styles"
import { InputBase, IconButton, Button } from "@mui/material"
import SearchIcon from "@mui/icons-material/Search"
import Filter from "./Filter"

const Container = styled("div")(({ theme }) => ({
  marginBottom: "14px",
  padding: "12px",
  backgroundColor: "white",
}))

const Header = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  "& > div": {
    display: "flex",
    alignItems: "center",
    border: "1px solid var(--card-border)",
    borderRadius: "8px",
  },
  "& button": {
    margin: "0 1rem",
    height: "20px",
    fontSize: "12px",
    textDecoration: "none !important",
    backgroundColor: "var(--nona-light-blue)"
  },
}))

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: "white",
  marginRight: theme.spacing(1),
  marginLeft: 0,
  width: "100%",
  minWidth: "300px",
}))

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}))

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    paddingRight: "80px", // Space for clear button
    transition: theme.transitions.create("width"),
    width: "100%",
    minWidth: "250px",
  },
}))

const ClearButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: "80px",
  top: "50%",
  transform: "translateY(-50%)",
  padding: "4px",
  fontSize: "16px",
}))

export default function SearchBar({ filterState, setFilterState, callFunction }) {
  const [searchText, setSearchText] = useState("")

  const handleSearch = () => {
    if (searchText.trim()) {
      setFilterState({ ...filterState, invoiceNo: searchText.trim() })
      callFunction(1)
    } else {
      const { invoiceNo, ...rest } = filterState
      setFilterState(rest)
      callFunction(1)
    }
  }

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch()
    }
  }

  const clearSearch = () => {
    setSearchText("")
    const { invoiceNo, ...rest } = filterState
    setFilterState(rest)
    callFunction(1)
  }

  return (
    <Container>
      <Header>
        <div>
          <Search>
            <form onSubmit={(e) => { e.preventDefault(); handleSearch(); }}>
              <SearchIconWrapper>
                <SearchIcon />
              </SearchIconWrapper>
              <StyledInputBase
                placeholder="Search by Invoice Number"
                inputProps={{ "aria-label": "search" }}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                onKeyPress={handleKeyPress}
              />
              {searchText && (
                <ClearButton size="small" onClick={clearSearch}>
                  ✕
                </ClearButton>
              )}
            </form>
          </Search>
          <Button variant="contained" size="small" onClick={handleSearch}>
            Search
          </Button>
        </div>
        <Filter filterState={filterState} setFilterState={setFilterState} callFunction={callFunction} />
      </Header>
    </Container>
  )
}